import * as React from 'react';
import './TransmittalHistoryTableLayout.scss';

export interface ITransmittalHistoryTableLayoutProps {
  mainTable: React.ReactNode;
  pkgTable: React.ReactNode;
  className?: string;
}

export const TransmittalHistoryTableLayout: React.FunctionComponent<ITransmittalHistoryTableLayoutProps> = ({
  mainTable,
  pkgTable,
  className = '',
}) => {
  return (
    <div className={`gcl-gems-transmittal-history-table-layout ${className}`}>
      <div className="gcl-gems-transmittal-history-table-layout-main-table">{mainTable}</div>
      <div className="gcl-gems-transmittal-history-table-layout-pkg-table">{pkgTable}</div>
    </div>
  );
};
